import { makeStyles, tokens } from '@fluentui/react-components'

export const useStyles = makeStyles({
  contextBar: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalS,
    // Top inset uses horizontalS per Figma (vertical gap labeled with that token).
    padding: `${tokens.spacingHorizontalS} ${tokens.spacingHorizontalS} ${tokens.spacingVerticalS} ${tokens.spacingHorizontalS}`,
    flexGrow: 0,
    flexShrink: 1,
    flexBasis: 'auto',
    minHeight: 0,
  },
  headerRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    // 24px row height to match Figma context row.
    height: tokens.spacingHorizontalXXXL,
    minHeight: tokens.spacingHorizontalXXXL,
    width: '100%',
    flexShrink: 0,
  },
  headerLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalS,
  },
  contextCountText: {
    color: tokens.colorNeutralForeground2,
    textAlign: 'left',
  },
  loadingText: {
    paddingLeft: tokens.spacingHorizontalS,
    paddingRight: tokens.spacingHorizontalS,
  },
  rightActionButton: {
    width: tokens.spacingHorizontalXXXL,
    height: tokens.spacingHorizontalXXXL,
  },
  tooltipContent: {
    paddingTop: tokens.spacingVerticalXXS,
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalS,
  },
})
